import { render, staticRenderFns } from "./courseDjustment-list.vue?vue&type=template&id=63d3d325&scoped=true"
import script from "./courseDjustment-list.vue?vue&type=script&lang=js"
export * from "./courseDjustment-list.vue?vue&type=script&lang=js"
import style0 from "./courseDjustment-list.vue?vue&type=style&index=0&id=63d3d325&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d3d325",
  null
  
)

export default component.exports